// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1rlfA","inner":"Footer_inner__2ZHmc","nextIcon":"Footer_nextIcon__3YIk9","innerLeft":"Footer_innerLeft__CHqj3"};